import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as components from "./components";
import * as VueGoogleMaps from "vue2-google-maps";

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

import Lightbox from '@morioh/v-lightbox'

const $ = require("jquery");
require('bootstrap');


window.$ = $;
Vue.config.productionTip = false;

// global register
Vue.use(Lightbox);


const options = {
  confirmButtonColor: '#dc3545',
  cancelButtonColor: '#d4d4d4',
  // cancelTextColor: '#595959'
}
 
Vue.use(VueSweetalert2, options)


Vue.use(VueGoogleMaps, {
    load: {
        key: "AIzaSyDLK7VwjPJWmp6NDpK8lQaG8sd97UVtn6c",
        libraries: "places" // necessary for places input
    }
});

for (const key in components) {
	Vue.component(key, components[key]);
}

Vue.directive('visible', function(el, binding) {
  el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

$(document).on('show.bs.modal', '.modal', function () {
  var zIndex = 1040 + (10 * $('.modal:visible').length);
  $(this).css('z-index', zIndex);
  setTimeout(function() {
      $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
  }, 0);
});
